<div class="m-1 wrapper-circle {{classBorder}} {{classBackground}}">
    <ng-content></ng-content>
</div>
